import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { AddModalButton, CloseButton, ToastScreen } from 'components';
import { LoadServices } from 'store';
import { billingDetailsStyle } from './styles';

export const SendBillingInvoice = ({ res, loadById, handleClose }) => {
  const classes = billingDetailsStyle()
  const [loadSend, setLoadSend] = useState(false);
  const handleSendEmail = async () => {
    setLoadSend(true);
    try {
      await LoadServices.sendBillingInvoiceEmail(loadById?.id);
      toast(
        <ToastScreen
          type={'success'}
          text={'Invoice was successfully sent to the email!'}
        />,
      );
      handleClose()
      setLoadSend(false);
    } catch (e) {
      toast(
        <ToastScreen
          type={'error'}
          text={e?.response?.data?.message || 'Something went wrong!'}
        />,
      );
      setLoadSend(false);
    }
  };

  return(
    <div>
      <div style={{ overflow: 'scroll', height: '700px' }} className={classes.paperWrapper}>
        <div className='space-between' style={{marginBottom: 14}}>
          <div/>
        <div>
          <p className={classes.customerBillingEmail}>
            The Document will be sent to{" "}
            {res?.customer?.billingEmail || res?.customer?.id?.billingEmail}
          </p>
        </div>
        <div>
          <CloseButton handleCLic={handleClose} />
        </div>
        </div>
        <div style={{ height: '702px', overflow: 'scroll' }}>
          <object
            style={{ overflow: 'hidden' }}
            data={res?.actualInvoiceDoc?.url}
            width="100%" height="100%"
          >
          </object>
        </div>
      </div>
      <div className={classes.paperFooter}>
        <div style={{ display: 'flex' }}>
          <AddModalButton
            loading={loadSend}
            styles={{ width: '238px' }}
            handleClick={handleSendEmail}
            text={'Send'}
          />
        </div>
      </div>
    </div>
  )
}